module.exports = __webpack_public_path__ + "img/29.e4bedcf9.png";